import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { FormComponent } from './form/form.component';
import { FormBaseControlStyleDirective } from './form-base-control-style.directive';
import { FormControlErrorComponent } from './form-control-error/form-control-error.component';
import { FormTranslationModule } from './translation-loader';

@NgModule({
  imports: [
    FormTranslationModule,
    FormComponent,
    FormControlErrorComponent,
    FormBaseControlStyleDirective,
  ],
  exports: [
    FormComponent,
    FormControlErrorComponent,
    FormBaseControlStyleDirective,
    ReactiveFormsModule,
  ],
})
export class FormModule {}
